module.exports = __webpack_public_path__ + "img/part_l.e89cb51e.png";